import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../constants";

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]*)/);
    if (sessionIdMatch) {
      const sessionId = sessionIdMatch[1];
      const processAuth = async () => {
        try {
          // Cookie is set by /auth/session on the response; just hydrate and navigate
          await axios.get(`${API}/auth/session`, {
            headers: { 'X-Session-ID': sessionId }
          });
          toast.success('Welcome!');
          // Force AuthContext rehydration by full-page reload to home
          window.location.replace('/');
        } catch (error) {
          toast.error('Authentication failed');
          navigate('/login', { replace: true });
        }
      };
      processAuth();
    } else {
      navigate('/login', { replace: true });
    }
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#050505] pt-24 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#D62828] mx-auto mb-4"></div>
        <p className="text-gray-400">Completing login...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
